// File: whatsapp.service-message-ops.js
import { axiosInstance, DEFAULT_SESSION } from './whatsapp.service-config';
import { ERROR_MESSAGES } from './whatsapp.service-errors';
import { formatChatId, _handleError } from './whatsapp.service-utils';

export const getMessages = async (chatId, limit = 100, before = null) => {
  try {
    const formattedChatId = formatChatId(chatId);
    let url = `${DEFAULT_SESSION}/chats/${formattedChatId}/messages?limit=${limit}&downloadMedia=false`;

    if (before) {
      url += `&before=${before}`;
    }

    console.log(`[WhatsApp Message Ops] Fetching messages for: ${formattedChatId}, limit: ${limit}, before: ${before || 'NONE'}`);
    const response = await axiosInstance.get(url);

    const messages = Array.isArray(response.data) ? response.data : (response.data.messages || []);

    const filteredMessages = messages
      .filter(msg => {
        if (msg._data?.type === 'e2e_notification') return false;
        if (msg._data?.type === 'gp2') {
          return msg._data.subtype === 'create' || msg.body.trim() !== '';
        }
        return msg.body.trim() !== '';
      })
      .map(msg => {
        const formattedMsg = {
          id: msg.id,
          timestamp: msg.timestamp,
          body: msg.body,
          from: msg.from,
          fromMe: msg.fromMe,
          hasMedia: msg.hasMedia || false,
          type: msg._data?.type || 'chat',
          subtype: msg._data?.subtype || null,
          notifyName: msg._data?.notifyName,
          ack: msg.ack,
          ackName: msg.ackName
        };

        if (msg._data?.author) {
          formattedMsg.author = {
            id: msg._data.author._serialized,
            name: msg._data.notifyName || msg._data.author.user
          };
        }

        if (msg.hasMedia && msg.media) {
          const mediaServerUrl = (typeof window !== 'undefined' && window.location.protocol === 'https:' &&
                                   window.location.host === 'crm.sumaroh.com')
                                  ? 'crm-wa.sumaroh.com' : 'wa.sumaroh.com';
          formattedMsg.mediaUrl = msg.media.url.replace('localhost:3000', mediaServerUrl);
          formattedMsg.mediaType = msg.media.mimetype;
          formattedMsg.fileName = msg.media.filename;
        }
        return formattedMsg;
      })
      .sort((a, b) => a.timestamp - b.timestamp);

    console.log('[WhatsApp Message Ops] Messages response:', {
      total: filteredMessages.length,
      firstMessage: filteredMessages[0],
      lastMessage: filteredMessages[filteredMessages.length - 1],
      isNewChat: filteredMessages.length === 0
    });

    return filteredMessages;
  } catch (error) {
    console.error('[WhatsApp Message Ops] Get messages error:', error);
    console.error('[WhatsApp Message Ops] Error response:', error.response?.data);
    const errorMessage = _handleError(error, ERROR_MESSAGES.MESSAGE_FETCH_FAILED);
    console.error(`[WhatsApp Message Ops] Get messages failed: ${errorMessage}`);
    throw new Error(errorMessage);
  }
};

export const sendTextMessage = async (chatId, text) => {
  try {
    const formattedChatId = formatChatId(chatId);
    console.log(`[WhatsApp Message Ops] Sending text message to: ${formattedChatId}`);
    const payload = {
      session: DEFAULT_SESSION,
      chatId: formattedChatId,
      text: text
    };

    console.log('[WhatsApp Message Ops] Send message payload:', payload);
    const response = await axiosInstance.post('/sendText', payload);
    console.log('[WhatsApp Message Ops] Send message response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[WhatsApp Message Ops] Send message error:', error);
    console.error('[WhatsApp Message Ops] Error response:', error.response?.data);
    const errorMessage = _handleError(error, ERROR_MESSAGES.SEND_MESSAGE_FAILED);
    console.error(`[WhatsApp Message Ops] Send message failed: ${errorMessage}`);
    throw new Error(errorMessage);
  }
};

export const sendFile = async (phoneNumber, fileUrl, filename, caption = '') => {
  try {
    // Note: sendFile uses phoneNumber directly, not chatId formatting from formatChatId
    console.log(`[WhatsApp Message Ops] Sending file to: ${phoneNumber}`);
    const payload = {
      phone: phoneNumber,
      url: fileUrl,
      filename: filename,
      caption: caption,
      session: DEFAULT_SESSION
    };

    console.log('[WhatsApp Message Ops] Send file payload:', payload);
    const response = await axiosInstance.post('/sendFile', payload);
    console.log('[WhatsApp Message Ops] Send file response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[WhatsApp Message Ops] Send file error:', error);
    console.error('[WhatsApp Message Ops] Error response:', error.response?.data);
    const errorMessage = _handleError(error, ERROR_MESSAGES.SEND_FILE_FAILED);
    console.error(`[WhatsApp Message Ops] Send file failed: ${errorMessage}`);
    throw new Error(errorMessage);
  }
};